<script>
import routes from '@src/router/routes.js'
import { menuItems } from '@src/router/menu'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { roles } from '@src/router/roles'
import { getSavedState } from '@src/utils/localStorage.js'
// import { encrypted } from '@utils/encrypt.js'

export default {
    components: {
        vueCustomScrollbar,
    },
    data() {
        return {
            isOpen: false,
            scrollSettings: {
                maxScrollbarLength: 60,
                swipeEasing: true,
                wheelSpeed: 0.3,
                wheelPropagation: false,
            },
            dropDownSettings: {
                isOpen: false,
                dropDown: '',
            },
        }
    },
    computed: {
        orderedRoutes() {
            return menuItems(routes)
        },
        isStaff() {
            const userRoles = getSavedState('auth.roles')
            return userRoles.includes('Staff')
        },
        submenuRoles() {
            const admRoles = [...roles.ConfigurationBasics, ...roles.Pedagogic]
            return [...new Set(admRoles)]
        },
    },
    methods: {
        toggleDropDown(dropDown) {
            const previousIsOpen = this.dropDownSettings.isOpen
            const previousDropDown = this.dropDownSettings.dropDown
            this.dropDownSettings = {
                dropDown,
                isOpen:
                    !!previousDropDown === dropDown ||
                    previousDropDown === '' ||
                    previousDropDown !== dropDown ||
                    !previousIsOpen,
            }
        },
        goTo(path, hasPermission) {
            if (path === '/courses') {
                this.$router.resolve({
                    path: 'https://mgbpro.metodologiagb.com.br/',
                })
                window.open('https://mgbpro.metodologiagb.com.br/', '_blank')
                return
            }
            if (path === '/certification') {
                window.open(
                    'https://mgbpro.metodologiagb.com.br/curso/certificacao-de-professores-mgb',
                    '_blank'
                )
                return
            }
            if (path === '/faq') {
                window.open('https://mgb.freshdesk.com/support/home/', '_blank')
                return
            }
            if (path === '/moduloavaliacao') {
                window.open(this.tokenModuloAvaliaçao(), '_blank')
                return
            }
            this.$router.push(path)
        },
        tokenModuloAvaliaçao() {
            const url =
                process.env.VUE_APP_SERVER === 'HM'
                    ? 'https://hm-painel.metodologiagb.com.br'
                    : 'https://avaliacoes.metodologiagb.com.br'
            // const locationPublicId = btoa(getSavedState('auth.selectedLocation').publicId);
            // const token = btoa(getSavedState('auth.currentUser').token);
            // return `${url}/handleExternalToken/${locationPublicId}/${token}`
            return `${url}/handleExternalToken/`
        },
    },
}
</script>

<template>
    <div class="sidenav">
        <b-nav vertical fill no-gutters class="flex-nowrap">
            <b-row class="mt-3">
                <b-col class="d-flex justify-content-center">
                    <a class="login__logo" href="#">
                        <img src="@assets/images/logos/logo-mgb.png" />
                    </a>
                </b-col>
            </b-row>
            <vue-custom-scrollbar
                class="scroll-area"
                :settings="scrollSettings"
            >
                <div class="sidenav__nav-items mt-3">
                    <div v-for="(item, index) in orderedRoutes" :key="index">
                        <div
                            v-if="item.path"
                            :class="{
                                active:
                                    $route.meta.module === item.meta.module &&
                                    item.path !== '/courses' &&
                                    item.path !== '/certification' &&
                                    item.path !== '/moduloavaliacao',
                            }"
                            class="sidenav__nav-route"
                            @click="goTo(item.path, true)"
                        >
                            <b-nav-item>
                                <svgicon
                                    :name="item.icon"
                                    height="20"
                                    width="20"
                                />
                                <span class="pl-2 pr-2">
                                    {{ $t(item.name) }}
                                </span>
                            </b-nav-item>
                        </div>
                        <template v-else>
                            <!-- Aparecer dropdown se houver ao menos um item com permissão, caso contrário, não aparecer o dropdown -->
                            <div v-if="isStaff" class="sidenav__nav-dropdown">
                                <div
                                    class="sidenav__nav-dropdown--name"
                                    @click.prevent="toggleDropDown(item.name)"
                                >
                                    <svgicon
                                        :name="item.icon"
                                        height="17"
                                        width="17"
                                    />
                                    <span class="pl-2">{{
                                        $t(item.name)
                                    }}</span>
                                    <svgicon
                                        class="arrow-icon"
                                        :class="{
                                            reverse:
                                                dropDownSettings.dropDown ===
                                                    item.name &&
                                                dropDownSettings.isOpen,
                                        }"
                                        name="icn_down"
                                        height="17"
                                        width="17"
                                    />
                                </div>
                                <ul
                                    :class="{
                                        'is-open':
                                            dropDownSettings.dropDown ===
                                                item.name &&
                                            dropDownSettings.isOpen,
                                    }"
                                >
                                    <li
                                        v-for="(subItem,
                                        subIndex) in item.items"
                                        :key="`${subItem.name} ${subIndex}`"
                                    >
                                        <div
                                            :class="{
                                                active:
                                                    $route.meta.module ===
                                                        subItem.meta.module &&
                                                    subItem.path !==
                                                        '/courses' &&
                                                    subItem.path !==
                                                        '/certification' &&
                                                    subItem.path !==
                                                        '/moduloavaliacao',
                                            }"
                                            class="sidenav__nav-route"
                                            @click="goTo(subItem.path, true)"
                                        >
                                            <b-nav-item
                                                :class="{
                                                    'inactive-route': !true,
                                                }"
                                                class="pl-3"
                                            >
                                                {{ $t(subItem.name) }}
                                            </b-nav-item>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </div>
            </vue-custom-scrollbar>
        </b-nav>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/side-bar';
</style>
